export const ObjectUtils = {
  isNullOrEmpty(object: object) {
    return !object || Object.keys(object).length === 0;
  },
  getNestedPropertyValue(propertyArray: any, parentObject: any): any {
    return propertyArray.reduce(
      (childObject: any, currentProperty: any) =>
        childObject && childObject[currentProperty] ? childObject[currentProperty] : null,
      parentObject
    );
  },
  getFieldKeyIgnoreCase(object: any, field: string): string | undefined {
    if (this.isNullOrEmpty(object)) {
      return undefined;
    }
    return Object.keys(object).find((key: any) => key.toLowerCase() === field.toLowerCase());
  },
  isNaN(value: any): boolean {
    return !value || Number.isNaN(+value);
  },
  deepCloneObject(object: any): any {
    return JSON.parse(JSON.stringify(object));
  }
};
